import Space from "./Space";

const FormFieldBox = ({children}: any) => {

    return (
        <Space styles={{position: 'relative', backgroundColor: '#F4F4F4', border: '1px solid #EADEDE', padding: 20, borderRadius: 5}}>
            {children}
        </Space>
    )

}

export default FormFieldBox